"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCloudOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M24.78 10.1A9.31 9.31 0 0016 4a9 9 0 00-8.95 8.06A7 7 0 008 26h15a8 8 0 008-8c0-4.1-2.47-7.2-6.22-7.9zM23 24H8a5 5 0 010-10h1v-1a7 7 0 017-7 7.23 7.23 0 017 5.24l.17.68.69.07C27 12.33 29 14.63 29 18a6 6 0 01-6 6z" })));
}
exports.default = SvgCloudOutline;
//# sourceMappingURL=CloudOutline.js.map